export default __webpack_public_path__ + "static/nasdaq-308-ade900748415324ae79ede7b80512a9c.png";